export default [{
  path: '/view/expirationcontrol',
  name: 'expirationcontrol',
  component: () => import('@/app/expiration-control/ExpirationControl'),
  meta: {
    // resource: 'expirationcontrol',
    // actions: ['read', 'write']
  }
}]
